import { render, staticRenderFns } from "./solicitudBaja.vue?vue&type=template&id=55b0dbce&"
import script from "./solicitudBaja.vue?vue&type=script&lang=js&"
export * from "./solicitudBaja.vue?vue&type=script&lang=js&"
import style0 from "./solicitudBaja.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports